import { render, staticRenderFns } from "./UploadPreview.vue?vue&type=template&id=ca752712&scoped=true"
import script from "./UploadPreview.vue?vue&type=script&lang=js"
export * from "./UploadPreview.vue?vue&type=script&lang=js"
import style0 from "./UploadPreview.vue?vue&type=style&index=0&id=ca752712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca752712",
  null
  
)

export default component.exports